import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Myprojects from "../general/Myprojects";
import LoadAnim from "./LoadAnim";

gsap.registerPlugin(ScrollTrigger);

export default function Grid({ setView, setPortfolioindex }) {
  const gridRef = useRef(null);

  useEffect(() => {
    if (!gridRef.current) return;

    gsap.fromTo(
      gridRef.current.children,
      { opacity: 0, y: 50, scale: 0.95 }, // Start: hidden, slightly down, smaller
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 3,
        stagger: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: gridRef.current,
          start: "top 95%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  return (
    <div
      ref={gridRef}
      className="pl-[70px] mt-[100px] flex gap-[10px] flex-wrap"
    >
      {Myprojects.map((item, index) => (
        <ProjectItem
          setPortfolioindex={setPortfolioindex}
          setView={setView}
          key={index}
          item={item}
          index={index}
        />
      ))}
    </div>
  );
}

const ProjectItem = ({ setPortfolioindex, setView, item, index }) => {
  const [hoverSrc, setHoverSrc] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  // const isLarge = index % 6 === 0 || index % 6 === 5;
  const isLarge = item.isLarge;
  const itemWidth = isLarge ? "w-[calc(50%-10px)]" : "w-[calc(25%-10px)]";

  return (
    <div
      className={`${itemWidth} mb-[15px] cursor-pointer group opacity-0`} // Ensure elements start invisible
      onClick={() => {
        setView("portfolio");
        setPortfolioindex(index);
      }}
      onMouseEnter={() => !hoverSrc && setHoverSrc(item.hover)}
      onMouseLeave={() => {
        setIsLoaded(false);
        setTimeout(() => setHoverSrc(null), 300);
      }}
    >
      <LoadAnim>
        <h2 className="text-white text-[16px] uppercase flex mb-[5px]">
          <span className="flex mr-[30px]">
            {index < 9 ? "0" + (index + 1) : index + 1}
          </span>{" "}
          {item.name}
        </h2>
      </LoadAnim>
      <LoadAnim className="w-full">
        <div className="relative w-full">
          <div className="w-[100%] h-[28vw] relative">
            <img
              alt="Project img"
              src={item.img}
              className="transition-opacity duration-300 object-cover absolute left-0 right-0 top-0 bottom-0 w-full h-full"
            />
            {hoverSrc && (
              <img
                className={`absolute z-10 left-0 top-0 right-0 opacity-0 [transition:all_ease_0.5s] object-cover absolute left-0 right-0 top-0 bottom-0 w-full h-full ${
                  isLoaded ? "opacity-100" : ""
                }`}
                alt="Project img"
                src={hoverSrc}
                onLoad={() => setTimeout(() => setIsLoaded(true), 100)}
              />
            )}
          </div>
        </div>
      </LoadAnim>
    </div>
  );
};
